module.exports = __webpack_public_path__ + "img/quantum1.bad5c1cf.png";